import { render, staticRenderFns } from "./ReferralBulkDialog.vue?vue&type=template&id=53b2be40&scoped=true&"
import script from "./ReferralBulkDialog.vue?vue&type=script&lang=js&"
export * from "./ReferralBulkDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReferralBulkDialog.vue?vue&type=style&index=0&id=53b2be40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2be40",
  null
  
)

export default component.exports